import styled from "styled-components";
import { Grid, SecondaryMenu } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const FullCatalogPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
  height: 100%;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: ${props =>
      props.background &&
      `url(${props.background}) ${
        props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? `19vw` : `-6vw`
      } 0 / contain no-repeat`};
    transition: opacity 0.2s linear;
    will-change: opacity;
    opacity: ${props => (props.background ? 1 : 0)};
  }
`;

export const BlockStyled = styled.div`
  & + & {
    width: 80%;
  }
`;

export const GridStyled = styled(Grid)`
  position: absolute;
  top: 0;
  bottom: 0;
  /* FIXME: Try to acces to the GridVirtualized styles from props instead of css attr */
  [role="rowgroup"] {
    margin: 0 auto;
    /* text-align: center; */
  }
`;

export const ImageStyled = styled.img`
  width: 10vw;
  position: absolute;
  top: -18vh;
  left: 50%;
  transform: translate(-50%);
`;

export const SecondaryMenuStyled = styled(SecondaryMenu)`
  ${props =>
    `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: -${props.theme.spacing.xsmall}`};
`;
